import { useContext, createContext } from 'react'

/**
 * Context type for skill rating modal functionality
 */
interface SkillRatingModalContextType {
  handleRateSkillClick: (selectedSkillSetIndex: number) => void
}

/**
 * Context for managing skill rating modal state across components
 */
export const SkillRatingModalContext = createContext<SkillRatingModalContextType | null>(null)

/**
 * Hook to access skill rating modal context
 * @throws {Error} If used outside of SkillRatingModalContext.Provider
 * @returns {SkillRatingModalContextType} Context methods for skill rating modal
 */
export const useSkillRatingModal = () => {
  const context = useContext(SkillRatingModalContext)
  
  if (!context) {
    throw new Error('useSkillRatingModal must be used within SkillRatingModalProvider')
  }

  return context
}
